import React from 'react';
import { Box, Typography } from '@mui/material';

interface DosStatusCardProps {
  index: number;
  showArrow?: boolean;
  arrowCondition?: boolean;
  label?: string;
  labelCondition?: boolean;
  backgroundColor?: string;
  children?: React.ReactNode;
}

export const DosStatusCard: React.FC<DosStatusCardProps> = ({
  index,
  showArrow = false,
  arrowCondition = false,
  label,
  labelCondition = false,
  backgroundColor = '#fff',
  children,
}) => {
  const displayArrow = showArrow && (arrowCondition || index === 0);

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        cursor: 'auto',
        justifyContent: 'space-between',
        mt: '-6px',
        pl: displayArrow ? 5 : 0,
        ...(displayArrow && {
          '&::before': {
            content: '""',
            position: 'absolute',
            left: 0,
            top: '57%',
            transform: 'translateY(-50%)',
            width: 0,
            height: 0,
            borderTop: '28px solid transparent',
            borderBottom: '27px solid transparent',
            borderRight: `40px solid ${backgroundColor}`,
          },
        }),
      }}
    >
      <Box
        sx={{
          background: backgroundColor,
          width: '100%',
          height: '100%',
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          mt: 1,
        }}
      >
        {labelCondition && label && (
          <Typography
            variant="caption"
            sx={{
              background: backgroundColor,
              color: '#111927',
              borderRadius: '6px',
              boxShadow: '0 1px 4px rgba(0,0,0,0.05)',
              fontWeight: 500,
              padding: '4px 7px',
              fontSize: '12px',
            }}
          >
            {label}
          </Typography>
        )}
        {children}
      </Box>
    </Box>
  );
};
